import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class CacheService {
    remove(key: string) {
        if (this.exist) localStorage.removeItem(key)
    }
    exist(key: string): boolean {
        return localStorage.getItem(key)  != null
    }
    get(key: string): any {
        if (!this.exist(key)) {
            return null;
        }
        let data: any = localStorage.getItem(key);
        return JSON.parse(data);
    }
    set(key: string, data: any): any {
        localStorage.setItem(key, JSON.stringify(data));
    }

   
}